import { gql } from '@apollo/client';

export const AccessoryFragment = gql`
  fragment AccessoryFragment on Accessory {
    sku
    articleNo
    productId
    dealerId
    title
    specification
    unitPrice
    sumPrice
    images {
      url
      id
    }
    carLines
    mainCategoryName
    deliveryTime {
      minWorkdays
      maxWorkdays
    }
  }
`;

export const FragmentAccessoryPDP = gql`
  fragment FragmentAccessoryPDP on Query {
    accessoryById(filter: $filter, accessoryId: $accessoryId) {
      accessory {
        ...AccessoryFragment
      }
      recommendedProducts {
        ...AccessoryFragment
      }
    }
  }
  ${AccessoryFragment}
`;
